var render = function render(){var _vm=this,_c=_vm._self._c;return _c('line-chart',{attrs:{"load":_vm.loadChartData}})
}
var staticRenderFns = []

export { render, staticRenderFns }